export const BUILD_VERSION =
  process.env.NEXT_PUBLIC_BUILD_VERSION ?? 'dev-local'

export const formatBuildVersion = () => `Build ${BUILD_VERSION}`
